import template from './listSaveQuotesInsurance.html';
import controller from './listSaveQuotesInsuranceCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    insuranceQuotes: '<',
  },
};
